import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const StarIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 20.32 19.32" {...props}>
    <path d="M15.33,12.23l5-4.85-6.89-1a.25.25,0,0,1-.19-.14L10.16,0,7.08,6.24a.25.25,0,0,1-.2.14L0,7.38l5,4.87a.23.23,0,0,1,.07.21L3.87,19.31l6.18-3.23a.19.19,0,0,1,.1,0h0a.29.29,0,0,1,.11,0l6.16,3.24-1.17-6.86A.25.25,0,0,1,15.33,12.23Zm-4.54,2.89a1.22,1.22,0,0,0-.62-.16h0a1.31,1.31,0,0,0-.61.15l-4.2,2.2.8-4.65a1.29,1.29,0,0,0-.38-1.21L2.36,8.15,7,7.48a1.42,1.42,0,0,0,1-.74l2.08-4.25,2.1,4.25a1.37,1.37,0,0,0,1,.74L18,8.15l-3.39,3.3a1.34,1.34,0,0,0-.4,1.18L15,17.31Z" />
  </SvgIcon>
));

export default React.memo(StarIcon);
